import React from 'react';

import { IconBaseProps } from 'src/ui-models/Icon';
import IconBase from '../icon-base/IconBase';

const GroupIcon: React.FC<IconBaseProps> = ({ width = 24, height = 24, color = 'currentColor' }) => {
  return (
    <IconBase color={color} width={width} height={height}>
      <path d="M2.8,10.1l7.4,4.2c0.5,0.3,1.1,0.5,1.7,0.5c0.6,0,1.2-0.2,1.7-0.5l7.4-4.2c0.5-0.3,0.8-0.9,0.9-1.7c0.1-0.9-0.2-1.6-0.9-2.1l-7.4-4.2c-1-0.7-2.3-0.7-3.4,0L2.8,6.3c-0.6,0.4-1,1.1-1,1.9C1.9,9,2.2,9.6,2.8,10.1z" />
      <path d="M21.1,12.9l-8,4.6c-0.7,0.5-1.6,0.4-2.4,0L2.7,13c-0.3-0.1-0.6,0-0.7,0.2c-0.1,0.3,0,0.6,0.2,0.7l8.1,4.5c0.5,0.3,1.1,0.5,1.7,0.5c0.6,0,1.2-0.2,1.7-0.5l8-4.6c0.2-0.1,0.3-0.5,0.2-0.7C21.7,12.9,21.4,12.8,21.1,12.9z" />
      <path d="M21.1,17l-8,4.6c-0.7,0.5-1.6,0.4-2.4,0l-8.1-4.5c-0.3-0.1-0.6,0-0.7,0.2c-0.1,0.3,0,0.6,0.2,0.7l8.1,4.5c0.5,0.3,1.1,0.5,1.7,0.5c0.6,0,1.2-0.2,1.7-0.5l8-4.6c0.2-0.1,0.3-0.5,0.2-0.7C21.7,17,21.4,16.9,21.1,17z" />
    </IconBase>
  );
};

export default GroupIcon;
